export var MetricMachineStates;
(function (MetricMachineStates) {
    MetricMachineStates["APPFEEDBACK"] = "appfeedback";
    MetricMachineStates["COLLAPSED"] = "collapsed";
    MetricMachineStates["QUESTION"] = "question";
    MetricMachineStates["SUBMITTED"] = "submitted";
})(MetricMachineStates || (MetricMachineStates = {}));
